/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The reason a deployment failed. `unknown` means Teral could not classify the
 *
 * @remarks
 * failure; see `message` for details.
 */
export const DeploymentErrorCode = {
  NoSchedulableRegions: "no_schedulable_regions",
  InvalidRuntimeSettings: "invalid_runtime_settings",
  CpuQuotaExceeded: "cpu_quota_exceeded",
  MemoryQuotaExceeded: "memory_quota_exceeded",
  StorageQuotaExceeded: "storage_quota_exceeded",
  BuildFailed: "build_failed",
  Unknown: "unknown",
} as const;
/**
 * The reason a deployment failed. `unknown` means Teral could not classify the
 *
 * @remarks
 * failure; see `message` for details.
 */
export type DeploymentErrorCode = ClosedEnum<typeof DeploymentErrorCode>;

/** @internal */
export const DeploymentErrorCode$inboundSchema: z.ZodNativeEnum<
  typeof DeploymentErrorCode
> = z.nativeEnum(DeploymentErrorCode);
